import './js/fetch-requests.js';
import './js/change-theme.js';
import './js/header.js';
import './js/hero.js';
import './js/categories.js';
import './js/popular-recipes.js';
import './js/filter.js';
import './js/recipes-cards.js';
import './js/pagination.js';
import './js/order-pop-up.js';
import './js/open-any-modal.js';
import './js/rating-pop-up.js';
import './js/recipe-pop-up.js';
import './js/scroll-up.js';
import './js/loader.js';
import './js/local-storage.js';
import './js/developer-modal.js';
